import { PureComponent } from 'react';
import { Icon, ModalVideo, RawHtml } from 'platfi-ui-components';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import { getOnboardingIcon } from 'enums/onboarding';
import Images from 'assets/images';

import { CAPITALISE_INTRODUCTION_VIDEO_ID } from 'constants';

import styles from './StepContent.scss';

@CSSModules(styles)
class StepContent extends PureComponent {
  static propTypes = {
    bullets: PropTypes.array,
    children: PropTypes.node,
    description: PropTypes.string,
    hasVideo: PropTypes.bool,
    icon: PropTypes.string,
    lead: PropTypes.string,
    notes: PropTypes.string,
    showProBadge: PropTypes.bool,
    title: PropTypes.string,
  };

  state = { videoModalOpen: false };

  toggleVideoModal = () =>
    this.setState((prevState) => ({ videoModalOpen: !prevState.videoModalOpen }));

  render() {
    const { videoModalOpen } = this.state;
    const { bullets, children, description, hasVideo, icon, lead, notes, showProBadge, title } =
      this.props;

    const ContentIcon = getOnboardingIcon(icon);

    return (
      <div styleName="a-step-content">
        {icon && (
          <div styleName="a-step-content__icon">
            <ContentIcon />
          </div>
        )}

        {showProBadge && (
          <div className="u-text-center">
            <Icon icon="capitalise_logo_pro" styleName="a-step-content__capitalise-logo" />
          </div>
        )}

        {title && <h3 styleName="a-step-content__title">{title}</h3>}

        <div styleName="a-step-content__content">
          {hasVideo && (
            <div className="u-content-center">
              <button
                onKeyPress={this.toggleVideoModal}
                onClick={this.toggleVideoModal}
                styleName="a-step-content__video"
                type="button"
              >
                <img alt={title} src={Images.videoThumbnail} />

                <div styleName="a-step-content__video-label">
                  <div styleName="a-step-content__video-icon">
                    <Icon className="a-svg-base" icon="play" />
                  </div>

                  <div>WATCH VIDEO</div>
                </div>
              </button>
            </div>
          )}

          {lead && (
            <p styleName="a-step-content__lead">
              <RawHtml>{lead}</RawHtml>
            </p>
          )}

          {description && (
            <div styleName="a-step-content__description">
              <RawHtml>{description}</RawHtml>
            </div>
          )}

          {notes && (
            <div styleName="a-step-content__notes">
              <RawHtml>{notes}</RawHtml>
            </div>
          )}

          {bullets && bullets.length && (
            <ul styleName="a-step-content__bullets">
              {bullets.map((bullet, index) => (
                <li key={index} styleName="a-step-content__bullets-item">
                  <Icon
                    className="a-svg-base"
                    icon="round_outlined_check"
                    styleName="a-step-content__bullets-icon"
                  />

                  <RawHtml>{bullet}</RawHtml>
                </li>
              ))}
            </ul>
          )}

          {children && <div styleName="a-step-content__children">{children}</div>}
        </div>

        {hasVideo && (
          <ModalVideo
            isOpen={videoModalOpen}
            closeModal={this.toggleVideoModal}
            videoId={CAPITALISE_INTRODUCTION_VIDEO_ID}
          />
        )}
      </div>
    );
  }
}

export default StepContent;
